import React, { useEffect, useState } from 'react';
import { TableRow, TableCell } from '@material-ui/core';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faTrash,
  faDna,
  faPen,
  faCopy,
  faEye,
} from '@fortawesome/pro-regular-svg-icons';

import { CustomSwitch, CustomTooltip } from '@/shared_elements';
import ApiKeyActionDialog from './ApiKeyActionDialog';
import CloneApiKeyModal from './CloneApiKeyModal';
import EditApiKeyModal from './EditApiKeyModal';
import { toastFlashMessage } from '@/utils';
import { globalPutService } from '@/utils/globalApiServices';
import { convertTimeWithTimezone } from '@/utils/time';

const SCENE = {
  Edit: 'edit',
  Clone: 'clone',
  Delete: 'delete',
  CloneResult: 'cloneResult',
};

export default function ApiKeyListingRow(props) {
  const { accountObj } = props;
  const [account, setAccount] = useState(accountObj ? accountObj : {});
  const [scene, setScene] = useState(null);
  const [cloneResult, setCloneResult] = useState();

  const updateStatus = (status) => {
    const formdata = {
      enabled: status,
    };
    globalPutService(`csp/api/account/${account.id}`, formdata).then(
      (response) => {
        if (response.status >= 200 && response.status < 300) {
          toastFlashMessage(`API Key updated successfully`, 'success');
          setAccount(response.data);
        }
      }
    );
  };

  useEffect(() => {
    setAccount(accountObj);
  }, [accountObj]);

  return (
    <>
      <TableRow data-testid="apiKeyListingRow">
        <TableCell item xs={4}>
          {account.displayName ? account.displayName : '--'}
        </TableCell>
        <TableCell>
          <div className="api-key-wrapper">
            <span data-testid="apiKeyListingRowApiKey">
              <CustomTooltip
                arrow
                title={
                  <div className="tooltip-content">
                    <p>
                      API KEY <br />
                      {account.apiKey}
                    </p>
                  </div>
                }
                placement="top"
              >
                <div className="img-wrapper">
                  <FontAwesomeIcon icon={faEye} size="lg" />
                </div>
              </CustomTooltip>
            </span>
            <span data-testid="apiKeyListingRowApiKeyCopyToClipboard">
              <CopyToClipboard
                text={account.apiKey}
                onCopy={() =>
                  toastFlashMessage(
                    'API Key has been copied to your clipboard',
                    'success'
                  )
                }
              >
                <CustomTooltip
                  arrow
                  placement="top"
                  title={<div className="tooltip-content">Copy</div>}
                >
                  <div className="img-wrapper">
                    <FontAwesomeIcon icon={faCopy} size="lg" />
                  </div>
                </CustomTooltip>
              </CopyToClipboard>
            </span>
          </div>
        </TableCell>
        <TableCell data-testid="apiKeyListingRowCreatedDate">
          {convertTimeWithTimezone(account.createDate)}
        </TableCell>
        <TableCell data-testid="apiKeyListingRowEnableSwitch">
          <CustomSwitch
            val={account.enabled ? true : false}
            handleChange={() => updateStatus(!account.enabled)}
          />
        </TableCell>
        <TableCell>
          <div className="actions-wrapper">
            <span data-testid="apiKeyListingRowEdit">
              <CustomTooltip
                arrow
                title={<div className="tooltip-content">Edit</div>}
                placement="top"
              >
                <div
                  className="img-wrapper"
                  onClick={() => setScene(SCENE.Edit)}
                >
                  <FontAwesomeIcon icon={faPen} size="lg" />
                </div>
              </CustomTooltip>
            </span>
            <span data-testid="apiKeyListingRowClone">
              <CustomTooltip
                arrow
                title={<div className="tooltip-content">Clone</div>}
                placement="top"
              >
                <div
                  className="img-wrapper clone"
                  onClick={() => setScene(SCENE.Clone)}
                >
                  <FontAwesomeIcon icon={faDna} size="lg" />
                </div>
              </CustomTooltip>
            </span>
            <span data-testid="apiKeyListingRowDelete">
              <CustomTooltip
                arrow
                title={<div className="tooltip-content">Delete</div>}
                placement="top"
              >
                <div
                  className="img-wrapper delete"
                  onClick={() => setScene(SCENE.Delete)}
                >
                  <FontAwesomeIcon icon={faTrash} size="lg" />
                </div>
              </CustomTooltip>
            </span>
          </div>
        </TableCell>
      </TableRow>
      {!!scene && [SCENE.Clone, SCENE.Delete].includes(scene) ? (
        <ApiKeyActionDialog
          type={scene}
          handleClose={() => {
            setScene(null);
          }}
          account={account}
          fetchApiAccounts={props.fetchApiAccounts}
          onCloneComplete={(account) => {
            setCloneResult(account);
            setScene(SCENE.CloneResult);
          }}
        />
      ) : null}
      <EditApiKeyModal
        open={scene === SCENE.Edit}
        account={account}
        onCancel={() => setScene(null)}
        onSave={(account) => {
          setAccount(account);
          setScene(null);
        }}
      />
      <CloneApiKeyModal
        open={scene === SCENE.CloneResult}
        account={cloneResult}
        onClose={() => setScene(null)}
      />
    </>
  );
}
